import {APP_STATUS} from "./constants";

export const RATING_STEPS = [
    { label: 'Upload Material', status: 'UPLOADING', nextStatus: 'ORGANIZATION_INFO' },
    { label: 'Organization Info', status: 'ORGANIZATION_INFO', nextStatus: 'PROGRAM_INFO' },
    { label: 'Program Info', status: 'PROGRAM_INFO', nextStatus: 'SUMMARY_REPORT' },
    { label: 'Summary Report', status: 'SUMMARY_REPORT', nextStatus: 'FULL_REPORT' },
    { label: 'Full Report', status: 'FULL_REPORT', nextStatus: 'COMPLETED' }
];
export const ASSESSMENT_STEPS = [
    { label: 'Select Assessment', status: APP_STATUS.PROGRAM_SUMMARY_REPORT_COMPLETED, nextStatus: 'ASSESS_ROLLOUT' },
    { label: 'Assessment Rollout', status: 'ASSESS_ROLLOUT', nextStatus: 'PREVIEW_ASSESS' },
    { label: 'Preview Assessment', status: 'PREVIEW_ASSESS', nextStatus: 'PUBLISH_ASSESS' },
    { label: 'Publish Assessment', status: 'PUBLISH_ASSESS', nextStatus: 'ACCESS_ASSESS_DASH' },
    { label: 'Access Assessment and Dashboard', status: 'ACCESS_ASSESS_DASH', nextStatus: 'COMPLETED' }
];
